












import { Component, Prop, Vue, Emit ,Watch} from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class WorkflowDialog extends Vue {
 @Prop({default:''}) public dialogCaption: string;
 @Prop({default:true}) public isSend: boolean;
 @Prop({default:0}) public stateId: number; 
 @Prop({default:null}) public item: Common.StateObject;  
 @Prop({default:null}) public onUpdate: (obj:any) =>{};  
 @Prop({default: null}) public workflowAction: Common.WorkflowAction;

 public isSendReportMail: boolean = false;
 public templateId: number = null;
 public templateName: string = null;
 public emailInfos: any[] = null;

 public mounted() {
  if (this.workflowAction && this.workflowAction.isShowSendReport) {
    this.templateId = this.workflowAction.templateId;
    this.isSendReportMail = this.templateId ? true : false;
  }
 }

 @Watch('isSendReportMail')
  public setTemplateId() {
    this.templateId = this.isSendReportMail ? this.workflowAction.templateId : null;
  }

 public async getTemplates(action: Common.WorkflowAction):Promise<Common.BindItem[]>{
  const workflowControllerName = action.workflow.controller.name;
    let result = this.$api.execute(new Common.WorkflowReportTemplateQuery(workflowControllerName));
    return result;
 }

  //***** メール送信処理 ******
  public async getEmailInfo(event: any){
    // GA4イベント
    this.$api.issueGA4trackevent(this.$route.path, 'ワークフローメール送信：送信確認');

    // メールデータ読み込み
    await this.$api.execute(new Common.EmailInfoQuery(this.item.className, [this.item], this.templateId)).then(queryResult => {
      const res = queryResult as Common.LoadResult;
      this.emailInfos = res ? res.result : null;
    });
    if (this.emailInfos) this.item.emailInfo = this.emailInfos[0];

    let msg = '';
    if(this.emailInfos.filter(obj=>!obj.mailAddress).length > 0) {
      msg = String.format("{0} のメールアドレスが設定されていません。\r\nこのままメールを送信せずにワークフローを進めますか？", this.emailInfos[0].counterpart.name);
      this.item.emailInfo.isSend = false;
    }else{
      if (this.emailInfos[0].counterpart) msg = String.format("{0} に {1} をメール送信します。\r\n実行してよろしいですか?", this.emailInfos[0].counterpart.name, this.templateName);
      else msg = String.format("{0} をメール送信します。\r\n実行してよろしいですか?", this.templateName); // 管理サイト対応
      this.item.emailInfo.isSend = true;
      this.item.emailInfo.templateId = this.templateId
    }
    await this.$api.modal.showDialog("メール送信",msg,false)
    this.$emit('hidden')
    // メール送信処理はsendしてAPIのPostで行う
  }

 public dialogMessage = '' ;
 public showDialog = true;
 public async onExecute(event: any){
     // ワークフローアクションでメール送信確認をONにしているか
     if (this.workflowAction && this.workflowAction.isShowSendReport) {
      // ワークフローメール送信前処理
      this.templateName = (this.$refs.atcReportTemplate as Components.AutoComplete)?.displayName;
      if (this.isSendReportMail && !this.templateId) {
        event.preventDefault();
        await this.$api.modal.show('無効な操作', '※「送信する帳票」が選択されていません。\r\n　「送信する帳票」を選択するか、\r\n　「帳票メールを送信」のチェックを外してください。', true, null);
        return;
      }
      if (!this.isSendReportMail && this.workflowAction.templateId) {
        // GA4イベント
        this.$api.issueGA4trackevent(this.$route.path, 'ワークフローメール送信：チェック外してフロー進行');
      }
     }

     if (this.isSend){
       // ワークフローメール送信
       if (this.isSendReportMail) {
        event.preventDefault();
        await this.getEmailInfo(event);
        if (this.item.emailInfo.isSend) this.$api.issueGA4trackevent(this.$route.path, `ワークフローメール送信完了(${this.templateName})`); // GA4イベント
       } else {
        let emailInfo: Common.EmailInfo = new Common.EmailInfo();
        this.item.emailInfo = emailInfo;
       }
       this.$api.send(this.getItemWithMessage(), this.stateId)
      .then(obj=>{
        if (this.isSendReportMail && this.item.emailInfo.isSend) {
          let links = [new Common.ModalLink('システムログ', '/operation/SystemLog')];
          this.$api.modal.show('処理結果','メール送信処理が開始されました。\r\n送信結果は、通知のメール、または以下のリンクから確認できます。',true,null,links,null,null,
            "<br><p class='cx_dialog_tips'>※ワークフローアクションに帳票を設定することで、自動でメールを送信することが可能になります。　詳細は<a href='https://support.s-flow.net/ja/articles/8259490' target='_blank'>サポートサイト</a>をご確認ください。</p>");
        }

        if (this.onUpdate) this.onUpdate(obj);    
        // 受発注管理がある場合利用状況のダイアログを開く
        if(this.$api.useSalesPurchaseOrderFunction == true){
          //利用状況照会ダイアログ
          if ((obj as Common.ObjectBase).eventCode == "roadmap"){
          //利用状況照会ダイアログを開く
          let componentClass = Vue.extend(Components.UsageDialog);
          var router = this.$router;
          let instance = new componentClass({
              router,
              propsData: {
                showRoadmap :true,
                roadmapMessage :null,
              },
            });
          instance.$mount();
          instance.$on('hidden', () => {
            //destroyできない
            instance.$el.parentElement.removeChild(instance.$el);
            instance.$destroy();
          });
          document.getElementById('app').appendChild(instance.$el);    
          } else if ((obj as Common.ObjectBase).eventCode == "roadmapCancel"){
            this.$api.execute(new Common.UsageQuery(Common.UsageCountType.Default)).then(obj=>{
              this.$api.setRoadmapRatio((obj as Common.UsageQueryResult));
            });
          }
        }
      });
     } else {
        this.$api.sendBack(this.getItemWithMessage())
        .then(obj=>{
            if (this.onUpdate) this.onUpdate(obj);
        });
     }
 }
 public onHidden(){
    this.$emit('hidden');     
 }
  public getItemWithMessage(){
    if (this.dialogMessage != ''){
        const msg = new Common.WorkflowMessage();
        msg.userId = this.$api.auth.userId;
        msg.isNote = false;
        msg.destination = ''; //宛先はサーバー側で更新する
        msg.description = this.dialogMessage;
        msg.timeStamp = null; //新規メッセージをマークする                
        this.item.workflowMessage = msg;
    }

    return this.item;
  } 
}
